import { PO_STAGE_COLOR_SLOT, PO_STAGE_LABEL, REQ_STAGE_LABEL, type PoStage, type ReqStage } from "@po/shared";

export const stageLabel = (s: string, lens: "req" | "po" = "req") =>
  lens === "po" ? (PO_STAGE_LABEL[s as PoStage] ?? s) : (REQ_STAGE_LABEL[s as ReqStage] ?? s);

/** CSS variable for a stage; PO stages reuse a requisition slot (SPEC §2.2). */
export const stageVar = (s: string, lens: "req" | "po" = "req") =>
  `var(--stage-${lens === "po" ? (PO_STAGE_COLOR_SLOT[s as PoStage] ?? s) : s})`;

export const MONEY_CAPTION = "PO ordered";

/** Sertica's enum values as its screens show them: "NotRequested" → "Not Requested". */
export const spaced = (s: string | null | undefined) => (s ? s.replace(/([a-z])([A-Z])/g, "$1 $2") : null);

export const int = (n: number | null | undefined) => (n == null ? "—" : new Intl.NumberFormat("en-US").format(Math.round(n)));
export const pct = (a: number, b: number) => (b ? `${Math.round((a / b) * 100)} %` : "—");

/** Relative time for the header ("3 min ago"). */
export function ago(ms: number): string {
  const m = Math.floor(ms / 60_000);
  if (m < 1) return "just now";
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} h ${m % 60} min ago`;
  return `${Math.floor(h / 24)} d ago`;
}
